import { render, staticRenderFns } from "./PageHeaderBar.vue?vue&type=template&id=3569a3de&scoped=true&"
import script from "./PageHeaderBar.vue?vue&type=script&lang=js&"
export * from "./PageHeaderBar.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderBar.vue?vue&type=style&index=0&id=3569a3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3569a3de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
